var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 21,
    viewBox: "0 0 46 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4877 4.5173C13.0693 3.96635 12.8359 3.29677 12.821 2.60457L2.60145 1.15112L0 19.4152L10.2195 20.8686L10.22 20.8691C10.4299 20.211 10.8387 19.6346 11.3891 19.2182C11.942 18.8036 12.6111 18.574 13.3024 18.5625L15.1276 5.68681C14.472 5.47883 13.8985 5.06959 13.4878 4.5172L13.4877 4.5173Z",
    fill: "#A9CF4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7208 0.790283L20.3414 2.5718C20.2808 3.2582 20.0056 3.90856 19.5546 4.42969C19.1165 4.97102 18.5142 5.3548 17.8384 5.52292L18.8221 18.4859C19.507 18.5527 20.1555 18.8274 20.6805 19.2727C21.2194 19.7175 21.6022 20.3222 21.7732 21L45.1206 19.1853L43.7208 0.790283ZM28.6919 5.40247C29.3351 5.35587 29.9427 5.70075 30.2328 6.27667C30.5229 6.85259 30.4379 7.54617 30.0176 8.03471C29.5973 8.52369 28.9239 8.7115 28.3115 8.5112C27.6986 8.3109 27.2668 7.76139 27.2163 7.11874C27.1832 6.69509 27.3206 6.27623 27.5977 5.95393C27.8744 5.63162 28.2683 5.43324 28.6919 5.4025L28.6919 5.40247ZM34.6601 15.9064V15.9069C34.0183 15.9444 33.4165 15.5932 33.1336 15.0163C32.8507 14.4395 32.9414 13.7487 33.3641 13.2646C33.7868 12.7799 34.4583 12.5964 35.0688 12.7987C35.6788 13.0014 36.1078 13.5499 36.1572 14.1906C36.1937 14.6181 36.0544 15.0423 35.7725 15.366C35.4901 15.6893 35.0885 15.8843 34.66 15.9069L34.6601 15.9064ZM27.5555 15.9064L26.7466 15.1633L35.3926 5.96011L36.2014 6.70319L27.5555 15.9064Z",
    fill: "#A9CF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v-2.361b0c2e292663c49a0d66734d684801.svg";
export { ForwardRef as ReactComponent };